import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { IDataLoaded } from '../../common/interfaces/default.interface';
import { GPW_EMAIL, GPW_EXTENSION, GPW_PHONE, NOMBRE_SISTEMA, LOGO_SISTEMA, LOGO_SISTEMA_TEXTO, LOGO_SIDE_SISTEMA, LOGINS, environment } from "src/environments/environment";
import Utils from '@utils/utils';
import { SistemaService } from '@services/sistema/sistema.service';
import { EstadoSistema } from 'src/app/common/interfaces/estadosistema.interface';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
})

export class StartComponent implements OnInit {

  logins = LOGINS.filter(x=>x.value == '1');
  selectedOption: any;
  showLogins: boolean = LOGINS.filter(x=>x.value == '1').length > 1;

  userInfo: string = "";
  loginForm = {} as FormGroup;
  isLoggedIn: IDataLoaded;
  mensajeSistema: string = "";
  estadoSistema: string = "";
  nSistema : string = NOMBRE_SISTEMA;
  logoSistema = LOGO_SISTEMA;
  logoSistemaTexto = LOGO_SISTEMA_TEXTO;
  logoSideSistema = LOGO_SIDE_SISTEMA;
  contactInfo = {
    email: GPW_EMAIL,
    phone: GPW_PHONE,
    extension: GPW_EXTENSION
  }

  constructor(
    private readonly router: Router,
    private readonly sistema: SistemaService
  ) {
    this.isLoggedIn = {
      hasErrors: false,
      isLoaded: true,
    };
  }

  async ngOnInit(): Promise<void> {
    this.selectedOption = LOGINS.filter(x=>x.predeterminado == '1')[0]

    let estadoSistema:EstadoSistema = await this.sistema.getEstadoSistemaByIdSistema();
    this.estadoSistema = estadoSistema.estadoSistema;
    this.mensajeSistema = estadoSistema.mensajeSistema;
  }

  public async signIn() {
    let codeState = Utils.generateStringCode();
    let hashState = Utils.generateHashState(codeState);

    if(this.selectedOption.tipo.includes('LOG_ClaveUnica') && environment.authorizer.usarSso) {
      window.location.href = Utils.getAuthorizerLoginUrlProvider('claveunica', hashState);
    } else if(this.selectedOption.tipo.includes('LOG_CorreoGoogle') && environment.authorizer.usarSso) {
      window.location.href = Utils.getAuthorizerLoginUrlProvider('Google', hashState);
    } else if(this.selectedOption.tipo.includes('LOG_JunjiAD') && environment.authorizer.usarSso) {
      window.location.href = Utils.getAuthorizerLoginUrlProvider('Microsoft', hashState);
    } else if(this.selectedOption.tipo.includes('LOG_CorreoMicrosoft') && environment.authorizer.usarSso) {
      window.location.href = Utils.getAuthorizerLoginUrlProvider('Microsoft', hashState);
    } else if(this.selectedOption.tipo.includes('LOG_UsuarioGesdep')) {
      this.router.navigate(['/login/1']);
    } else if(this.selectedOption.tipo.includes('LOG_UsuarioLocal')) {
      this.router.navigate(['/login/2']);
    }
  }
}